import { render, staticRenderFns } from "./SageSupplierTypesSettings.vue?vue&type=template&id=d1a34cd0&scoped=true&"
import script from "./SageSupplierTypesSettings.vue?vue&type=script&lang=js&"
export * from "./SageSupplierTypesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a34cd0",
  null
  
)

export default component.exports